import type from '../commons/slotActionStatus';

const DEFAULT_STATE = {
    data: [],
    error: null,
    requestState: false,
    status: null,
    slots: [],
    silentSlot:[],
    page: 1,
    hasNext: true,
};

export const slotReducer = (state = DEFAULT_STATE, action) => {
    const actionType = action.type;
    let data;
    let error = action.error;
    let requestState = action.requestState;
    let status = action.status;
    switch (actionType) {

        case type.GET_SLOTS_REQUEST:
            return { ...state, requestState,  status };

        case type.GET_SLOTS_SUCCESS:
            const { data: newData, hasNext, pageNo } = action.payload;
            return {
                ...state,
                requestState,
                status,
                error: null,
                data: pageNo === 1 ? newData : [...state.data, ...newData],
                page: pageNo,
                hasNext,
            };

        case type.GET_SLOTS_FAILURE:
            return { ...state, error, requestState, status };

        case type.GET_SLOTS_SILENTLY_REQUEST:
            return { ...state, requestState, silentSlot: [], status };

        case type.GET_SLOTS_SILENTLY_SUCCESS:
            return {
                ...state,
                silentSlot: action.result,
                requestState,
                status,
                error: null
            };

        case type.GET_SLOTS_SILENTLY_FAILURE:
            return { ...state, error, requestState, status };

        case type.GET_DATE_SLOTS_REQUEST:
            return { ...state, requestState, slots: [], status };

        case type.GET_DATE_SLOTS_SUCCESS:
            return {
                ...state,
                slots: action.result,
                requestState,
                status,
                error: null
            };

        case type.GET_DATE_SLOTS_FAILURE:
            return { ...state, error, requestState, status };

        case type.RESET_SLOTS_STATE:
            return {
                ...state,
                slots: [],
                silentSlot: [],
                data: [],
            };
            
        default:
            return state;
    }
};
